import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientContinuable } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { Package } from './package'
import { environment } from '../../../../environments/environment'
import { Observable } from 'rxjs'
import { PackagePatch } from './package-patch'

@Injectable({
  providedIn: 'root',
})
export class PackageService extends RestClientContinuable<Package, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/packages', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Query                                                                   *
   *                                                                         *
   **************************************************************************/

  public listAll(filters?: Filter[]) {
    const params = HttpParamsBuilder.start().appendFilters(filters).build()

    return this.http.get<Package[]>(this.restEndpoint + '/list', { params: params })
  }

  /***************************************************************************
   *                                                                         *
   * Patch                                                                   *
   *                                                                         *
   **************************************************************************/

  public patch(patch: PackagePatch): Observable<Package> {
    return super.patchInternal(patch.id, patch)
  }

  /***************************************************************************
   *                                                                         *
   * api/packages/one                                                        *
   *                                                                         *
   **************************************************************************/

  public findOne(number: string): Observable<Package> {
    const params = HttpParamsBuilder.start().append('number', number).build()

    return this.http.get<Package>(this.restEndpoint + '/one', { params: params })
  }

  public getConfig(): Observable<PackageConfig> {
    return this.http.get<PackageConfig>(this.restEndpoint + '/config')
  }
}

export class PackageConfig {
  public numberPrefix: string
}
